var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useState } from 'react';
import FadeIn from '../../../../components/Animation/FadeIn';
import Button from '../../../../components/Button';
import { useWizard } from '../../../../hooks/useWizard';
import Heading from '../../../../components/Typography/Heading';
import FormRow from '../../../../components/Form/Row';
import Select from '../../../../components/Fields/Select';
import TrueFalseInput from '../../../../components/Fields/TrueFalseInput';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { useValidation } from '../../../../hooks/useValidation';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import axiosInstance from '../../../../config/axios';
import { api } from '../../../../config/api';
import { serialize } from 'object-to-formdata';
import { RoutePaths } from '../../../../config/routes';
import { useSignIn } from 'react-auth-kit';
import jwtDecode from 'jwt-decode';
import Checkbox from '../../../../components/Fields/Checkbox';
var ProfessionalIdentity = function () {
    var navigate = useNavigate();
    var signIn = useSignIn();
    var values = useOutletContext().values;
    var clearWizard = useWizard().clearWizard;
    var _a = useValidation(), textOptional = _a.textOptional, booleanNullable = _a.booleanNullable, consentIdentity = _a.consentIdentity;
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState(false), ready = _c[0], setReady = _c[1];
    var _d = useState({
        genders: [],
        pronouns: [],
    }), identities = _d[0], setIdentities = _d[1];
    var schema = yup.object().shape({
        gender: textOptional,
        display_gender: booleanNullable,
        pronoun: textOptional,
        display_pronoun: booleanNullable,
        consent_identity: consentIdentity,
    });
    var _e = useForm({
        resolver: yupResolver(schema),
        defaultValues: __assign(__assign({}, values), { display_gender: false }),
    }), handleSubmit = _e.handleSubmit, control = _e.control;
    var onSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var formData, createUser, _a, token, user, isSignedIn, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setLoading(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    formData = serialize(data, { indices: true });
                    return [4 /*yield*/, axiosInstance.post(api.account.createProfessional, formData)];
                case 2:
                    createUser = _b.sent();
                    _a = createUser.data, token = _a.token, user = _a.user;
                    isSignedIn = signIn({
                        token: token,
                        tokenType: 'Bearer',
                        expiresIn: jwtDecode(token).exp,
                        authState: user,
                    });
                    clearWizard();
                    if (isSignedIn) {
                        setLoading(false);
                        navigate(RoutePaths.DASHBOARD, { state: { success: true } });
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    setLoading(false);
                    console.log(error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        axiosInstance.get(api.identities.all).then(function (_a) {
            var data = _a.data;
            setIdentities(data);
            setReady(true);
        });
    }, []);
    if (!ready)
        return null;
    return (<FadeIn>
      <div className="flex flex-col gap-10 py-10">
        <div>
          <Heading level={1} type="h4">
            Quelle est votre identité&nbsp;?
          </Heading>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="flex flex-col gap-6">
            <FormRow>
              <Select label="Genre" name="gender" control={control} instructions="Indiquez clairement votre identité et soyez reconnu·e comme telle." subInstructions="Si vous vous identifiez au genre féminin et que cette identité vous a été assignée à la naissance, vous êtes une femme cisgenre." choices={identities.genders}/>
            </FormRow>
            {/*<FormRow>
          <TrueFalseInput
            label="Afficher sur mon profil"
            name="display_gender"
            control={control}
          />
        </FormRow>*/}

            <FormRow>
              <Select label="Pronom" name="pronoun" control={control} instructions="Comment doit-on s’adresser à vous ?" choices={identities.pronouns}/>
            </FormRow>
            <FormRow>
              <TrueFalseInput label="Afficher sur mon profil" name="display_pronoun" control={control}/>
            </FormRow>

            <FormRow>
              <Checkbox ariaLabel="En cochant cette case, je consens à l'utilisation des données relatives à mon genre et mon pronom telles qu'indiquées sur cette page. Ces données sont sécurisées et sont uniquement traitées en interne. Vous trouverez également plus d'infos dans notre politique de confidentialité" name="consent_identity" control={control} required>
                <>
                  En cochant cette case, je consens à l'utilisation des données relatives à mon
                  genre et mon pronom telles qu'indiquées sur cette page. Ces données sont
                  sécurisées et sont uniquement traitées en interne. Vous trouverez également plus
                  d'infos dans notre
                  <span className="cursor-pointer font-medium text-brand-01 underline transition-colors hover:text-brand-02" onClick={function () { return (window.location.href = '/politique-de-confidentialite'); }}>
                    {' '}
                    politique de confidentialité
                  </span>
                </>
              </Checkbox>
            </FormRow>

            <div className="flex items-center justify-between">
              <Button submit type="inline">
                Passer
              </Button>
              <Button submit loading={loading}>
                Valider mon profil
              </Button>
            </div>
          </div>
        </form>
      </div>
    </FadeIn>);
};
export default ProfessionalIdentity;
